<big-ui-card [hasLink]="!!data.link">
    <div
        *transloco="let t; prefix: 'uiCard'"
        [class]="classList"
        [ngClass]="{
            'md:flex-row': cardIndex === 4
        }">
        <ng-container>
            @if (cardIndex !== 4) {
                <div class="block">
                    <big-ui-picture
                        [model]="data.image"
                        class="block w-full h-[200px]" />
                </div>
            } @else {
                <div class="h-[200px] md:h-full h-max-[280px] md:w-1/2 md:order-last">
                    <big-ui-picture [model]="data.image" />
                </div>
            }
        </ng-container>
        <div
            class="flex flex-col h-full px-4 pb-2 md:pb-3"
            [ngClass]="{
                'md:w-1/2': cardIndex === 4
            }">
            <div class="flex-auto pt-8 pb-4 grow">
                <h4 class="mb-4 group-hover/item:text-primary-light">{{ data.title }}</h4>
                @if (data.text) {
                    <p
                        class="overflow-hidden tracking-wide line-clamp-4"
                        [innerHTML]="data.text | nl2br | sanitize: securityContext"></p>
                }
                @if (data.link) {
                    <big-ui-link
                        class="text-primary hover:text-primary-light"
                        [href]="data.link.href"
                        [linkClass]="'tracking-wide font-bold no-underline after:absolute after:inset-0 flex items-center'">
                        <span class="sr-only">{{ t('linkTitle', { nodeTitle: data.title }) }}</span>
                    </big-ui-link>
                }
            </div>
            @if (data.subjectAreas) {
                <ul class="flex flex-wrap items-end -mt-4 -ml-4">
                    @for (subjectArea of data.subjectAreas; track $index) {
                        <li
                            class="px-6 py-1 mt-4 ml-4 bg-gray-400 rounded-md text-primary-dark"
                            [ngClass]="{ 'border-primary-light! border': subjectArea.id === selectedAreaId }"
                            [innerHTML]="subjectArea.name | sanitize: securityContext"></li>
                    }
                </ul>
            }
        </div>
    </div>
</big-ui-card>
